// extracted by mini-css-extract-plugin
export var button = "_bc-0";
export var icon = "_bc-1";